module.exports = __webpack_public_path__ + "img/flexible.0742f67d.png";